export const STRINGS = {
  fr: {
    lang: "fr",
    eyebrow: "Voyance contemporaine · Intelligence sensible",
    titleA: "L'Oracle",
    titleB: "de Cristal",
    invite: "La boule vous écoute. Quelle question portez-vous ?",
    placeholder: "Posez votre question…",
    clarifyPlaceholder: "Votre réponse…",
    clarifyLabel: "L'oracle souhaite une précision",
    tooShort: "La boule n'entend que les vraies questions…",
    errorGeneric: "Les brumes se sont emmêlées… réessayez dans un instant.",
    loadingLines: [
      "La boule traverse les brumes…",
      "Les astres murmurent votre nom…",
      "Une vérité se forme dans le cristal…",
      "La vision se précise…",
    ],
    terminer: "Terminer",
    yourQuestion: "Votre question",
    visionForming: "La vision se dessine dans le cristal…",
    share: "Partager la vision",
    sharePreparing: "La carte se forme…",
    shareDoneShared: "Votre vision a été partagée.",
    shareDoneDownloaded: "Votre carte a été téléchargée.",
    shareError: "La carte s'est perdue dans les brumes… réessayez.",
    voiceOn: "Activer la voix de l'oracle",
    voiceOff: "Couper la voix de l'oracle",
    modeFree: "Réponse libre",
    modeYesNo: "Oui ou Non",
    ritual: "Le rituel",
    enter: "Entrer dans l'oracle",
    back: "Retour",
    welcomeTagline: "Les brumes gardent mille visions. Traversez le rituel, puis venez poser la vôtre.",
    ctaLine: "Le rituel est connu. La boule vous attend.",
    manifestoTitle: "Trois temps, une vérité.",
    chapters: [
      {
        num: "01",
        title: "La Question",
        text: "Formulez ce qui vous habite. Une vraie question, sincère, est la seule clé qui ouvre les brumes. Si elle est floue, la boule vous demandera jusqu'à trois précisions avant de révéler sa vision.",
      },
      {
        num: "02",
        title: "La Recherche",
        text: "La fumée s'agite, tourbillonne, interroge les courants invisibles. L'oracle cherche une réponse intelligente, sensible et respectueuse — jamais une prédiction froide.",
      },
      {
        num: "03",
        title: "La Révélation",
        text: "Les brumes se dissipent. Une image naît au cœur du cristal, et sous la boule, des mots viennent éclairer votre chemin. Puis tout s'efface, prêt pour un nouveau destin.",
      },
    ],
    marqueeWords: [
      "La boule veille",
      "Posez votre question",
      "Les brumes répondent",
      "Une vision se révèle",
      "Écoutez le silence",
    ],
    footer: "L'Oracle de Cristal — les brumes ne prédisent pas, elles éclairent.",
    sendAria: "Consulter l'oracle",
    soundOn: "Activer l'ambiance sonore",
    soundOff: "Couper l'ambiance sonore",
  },
  en: {
    lang: "en",
    eyebrow: "Contemporary divination · Sensitive intelligence",
    titleA: "The Crystal",
    titleB: "Oracle",
    invite: "The ball is listening. What question do you carry?",
    placeholder: "Ask your question…",
    clarifyPlaceholder: "Your answer…",
    clarifyLabel: "The oracle seeks clarity",
    tooShort: "The ball only hears true questions…",
    errorGeneric: "The mists got tangled… try again in a moment.",
    loadingLines: [
      "The ball drifts through the mists…",
      "The stars whisper your name…",
      "A truth is forming in the crystal…",
      "The vision grows clearer…",
    ],
    terminer: "Finish",
    yourQuestion: "Your question",
    visionForming: "The vision is taking shape in the crystal…",
    share: "Share the vision",
    sharePreparing: "The card is forming…",
    shareDoneShared: "Your vision has been shared.",
    shareDoneDownloaded: "Your card has been downloaded.",
    shareError: "The card got lost in the mists… try again.",
    voiceOn: "Turn the oracle's voice on",
    voiceOff: "Turn the oracle's voice off",
    modeFree: "Free answer",
    modeYesNo: "Yes or No",
    ritual: "The ritual",
    enter: "Enter the oracle",
    back: "Back",
    welcomeTagline: "The mists hold a thousand visions. Walk through the ritual, then come and ask your own.",
    ctaLine: "The ritual is known. The ball awaits you.",
    manifestoTitle: "Three movements, one truth.",
    chapters: [
      {
        num: "01",
        title: "The Question",
        text: "Speak what lives within you. A true, sincere question is the only key that opens the mists. If it is vague, the ball will ask you up to three clarifications before revealing its vision.",
      },
      {
        num: "02",
        title: "The Search",
        text: "The smoke stirs, swirls, questions the invisible currents. The oracle seeks an intelligent, sensitive and respectful answer — never a cold prediction.",
      },
      {
        num: "03",
        title: "The Revelation",
        text: "The mists part. An image is born at the heart of the crystal, and beneath the ball, words come to light your path. Then everything fades, ready for a new destiny.",
      },
    ],
    marqueeWords: [
      "The ball keeps watch",
      "Ask your question",
      "The mists answer",
      "A vision is revealed",
      "Listen to the silence",
    ],
    footer: "The Crystal Oracle — the mists do not predict, they illuminate.",
    sendAria: "Consult the oracle",
    soundOn: "Turn sound ambience on",
    soundOff: "Turn sound ambience off",
  },
};
